let language = 'fr';
// This CRA application has one browser language provider, with no server rendering.
export function setFormattingLanguage(next) { language = next === 'en' ? 'en' : 'fr'; }
export function formattingLocale() { return language === 'en' ? 'en-GB' : 'fr-FR'; }
